import { render, staticRenderFns } from "./tipoDenticaoReportSelect.vue?vue&type=template&id=773df166&scoped=true"
import script from "./tipoDenticaoReportSelect.vue?vue&type=script&lang=js"
export * from "./tipoDenticaoReportSelect.vue?vue&type=script&lang=js"
import style0 from "./tipoDenticaoReportSelect.vue?vue&type=style&index=0&id=773df166&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773df166",
  null
  
)

export default component.exports